"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLoggedIn = exports.setTurnedOnState = exports.setAdditionalFeatures = exports.addToTotalMediafilesSize = exports.setTotalMediafilesSize = exports.resetAutoplayTrigger = exports.setAutoPlayTriggered = exports.setConnected = exports.updateBindingCode = exports.setAutoStart = exports.setKioskMode = exports.setPreloadTracks = exports.setAutoPlay = exports.setAnalyticsEnabled = exports.setLastCleanupMediadata = exports.setLastSleepCheck = exports.setLastPlayStateSync = exports.setSleepMode = exports.setTheme = exports.setPlaybackLock = void 0;
var initialState = {
    analyticsEnabled: true,
    turnedOn: true,
    autoStart: false,
    autoPlay: false,
    isConnected: true,
    connectionQuality: 100,
    kioskMode: false,
    theme: "auto",
    lastPlayStateSync: 0,
    lastSleepCheck: 0,
    lastCleanupMediadata: 0,
    autoPlayTriggered: false,
    totalMediafilesSize: 0,
    preloadTracks: true,
    additionalFeatures: [],
    playbackLock: {
        offline: false,
        interrupted: false,
    },
};
setPlaybackLock.type = "global/setPlaybackLock";
function setPlaybackLock(payload) {
    return {
        type: setPlaybackLock.type,
        payload: payload,
    };
}
exports.setPlaybackLock = setPlaybackLock;
setTheme.type = "global/setTheme";
function setTheme(theme) {
    return {
        type: setTheme.type,
        payload: {
            theme: theme,
        },
    };
}
exports.setTheme = setTheme;
setSleepMode.type = "global/setSleepMode";
function setSleepMode(shouldSleep, start, end) {
    return {
        type: setSleepMode.type,
        payload: {
            shouldSleep: shouldSleep,
            start: start,
            end: end,
        },
    };
}
exports.setSleepMode = setSleepMode;
setLastPlayStateSync.type = "global/setLastPlayStateSync";
function setLastPlayStateSync() {
    return {
        type: setLastPlayStateSync.type,
        payload: {},
    };
}
exports.setLastPlayStateSync = setLastPlayStateSync;
setLastSleepCheck.type = "global/setLastSleepCheck";
function setLastSleepCheck(lastSleepCheck) {
    return {
        type: setLastSleepCheck.type,
        payload: {
            lastSleepCheck: lastSleepCheck ? lastSleepCheck : Date.now(),
        },
    };
}
exports.setLastSleepCheck = setLastSleepCheck;
setLastCleanupMediadata.type = "global/setLastCleanupMediadata";
function setLastCleanupMediadata() {
    return {
        type: setLastCleanupMediadata,
        payload: {},
    };
}
exports.setLastCleanupMediadata = setLastCleanupMediadata;
setAnalyticsEnabled.type = "global/setAnalyticsEnabled";
function setAnalyticsEnabled(state) {
    return {
        type: setAnalyticsEnabled.type,
        payload: {
            state: state,
        },
    };
}
exports.setAnalyticsEnabled = setAnalyticsEnabled;
setAutoPlay.type = "global/setAutoPlay";
function setAutoPlay(state) {
    return {
        type: setAutoPlay.type,
        payload: {
            state: state,
        },
    };
}
exports.setAutoPlay = setAutoPlay;
setPreloadTracks.type = "global/setPreloadTracks";
function setPreloadTracks(state) {
    return {
        type: setPreloadTracks.type,
        payload: {
            state: state,
        },
    };
}
exports.setPreloadTracks = setPreloadTracks;
setKioskMode.type = "global/setKioskMode";
function setKioskMode(state) {
    return {
        type: setKioskMode.type,
        payload: {
            state: state,
        },
    };
}
exports.setKioskMode = setKioskMode;
setAutoStart.type = "global/setAutoStart";
function setAutoStart(state) {
    return {
        type: setAutoStart.type,
        payload: {
            state: state,
        },
    };
}
exports.setAutoStart = setAutoStart;
updateBindingCode.type = "global/setBindingCode";
function updateBindingCode(code) {
    return {
        type: updateBindingCode.type,
        payload: {
            code: code,
        },
    };
}
exports.updateBindingCode = updateBindingCode;
setConnected.type = "global/setConnected";
function setConnected(state, quality) {
    return {
        type: setConnected.type,
        payload: {
            state: state,
            quality: quality !== null && quality !== void 0 ? quality : 100,
        },
    };
}
exports.setConnected = setConnected;
setAutoPlayTriggered.type = "global/setAutoPlayTriggered";
function setAutoPlayTriggered() {
    return {
        type: setAutoPlayTriggered.type,
        payload: {},
    };
}
exports.setAutoPlayTriggered = setAutoPlayTriggered;
resetAutoplayTrigger.type = "global/resetAutoplayTrigger";
function resetAutoplayTrigger() {
    return {
        type: resetAutoplayTrigger.type,
        payload: {},
    };
}
exports.resetAutoplayTrigger = resetAutoplayTrigger;
setTotalMediafilesSize.type = "global/setTotalMediafilesSize";
function setTotalMediafilesSize(size) {
    return {
        type: setTotalMediafilesSize.type,
        payload: {
            size: size,
        },
    };
}
exports.setTotalMediafilesSize = setTotalMediafilesSize;
addToTotalMediafilesSize.type = "global/addToTotalMediafilesSize";
function addToTotalMediafilesSize(size) {
    return {
        type: addToTotalMediafilesSize.type,
        payload: {
            size: size,
        },
    };
}
exports.addToTotalMediafilesSize = addToTotalMediafilesSize;
setAdditionalFeatures.type = "global/setAdditionalFeatures";
function setAdditionalFeatures(features) {
    return {
        type: setAdditionalFeatures.type,
        payload: {
            features: features,
        },
    };
}
exports.setAdditionalFeatures = setAdditionalFeatures;
setTurnedOnState.type = "global/setTurnedOnState";
function setTurnedOnState(state) {
    return {
        type: setTurnedOnState.type,
        payload: { state: state },
    };
}
exports.setTurnedOnState = setTurnedOnState;
setLoggedIn.type = "global/setLoggedIn";
function setLoggedIn(state) {
    return {
        type: setLoggedIn.type,
        payload: { state: state },
    };
}
exports.setLoggedIn = setLoggedIn;
function globalReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case setPlaybackLock.type:
            return __assign(__assign({}, state), { playbackLock: __assign(__assign({}, state.playbackLock), action.payload) });
        case setTheme.type:
            return __assign(__assign({}, state), { theme: action.payload.theme });
        case updateBindingCode.type:
            return __assign(__assign({}, state), { bindingCode: action.payload.code });
        case setAnalyticsEnabled.type:
            return __assign(__assign({}, state), { analyticsEnabled: action.payload.state });
        case setAutoStart.type:
            return __assign(__assign({}, state), { autoStart: action.payload.state });
        case setAutoPlay.type:
            return __assign(__assign({}, state), { autoPlay: action.payload.state });
        case setPreloadTracks.type:
            return __assign(__assign({}, state), { preloadTracks: action.payload.state });
        case setKioskMode.type:
            return __assign(__assign({}, state), { kioskMode: action.payload.state });
        case setConnected.type:
            return __assign(__assign({}, state), { isConnected: action.payload.state, lastConnected: state.isConnected ? Date.now() : state.lastConnected, connectionQuality: action.payload.quality });
        case setLastPlayStateSync.type:
            return __assign(__assign({}, state), { lastPlayStateSync: Date.now() });
        case setLastSleepCheck.type:
            return __assign(__assign({}, state), { lastSleepCheck: Date.now() });
        case setLastCleanupMediadata.type:
            return __assign(__assign({}, state), { lastCleanupMediadata: Date.now() });
        case setSleepMode.type:
            return __assign(__assign({}, state), { shouldSleep: action.payload.shouldSleep, startSleep: action.payload.start, endSleep: action.payload.end });
        case setTurnedOnState.type:
            return __assign(__assign({}, state), { turnedOn: action.payload.state });
        case setAutoPlayTriggered.type:
            return __assign(__assign({}, state), { autoPlayTriggered: true });
        case resetAutoplayTrigger.type:
            return __assign(__assign({}, state), { autoPlayTriggered: false });
        case setTotalMediafilesSize.type:
            return __assign(__assign({}, state), { totalMediafilesSize: action.payload.size });
        case addToTotalMediafilesSize.type:
            return __assign(__assign({}, state), { totalMediafilesSize: state.totalMediafilesSize + action.payload.size });
        case setAdditionalFeatures.type:
            return __assign(__assign({}, state), { additionalFeatures: action.payload.features });
        case setLoggedIn.type:
            return __assign(__assign({}, state), { loggedIn: action.payload.state });
        default:
            return state;
    }
}
exports.default = globalReducer;
//# sourceMappingURL=global.js.map